const role = {
  ROLE: 'ROLE',
  ROLES: 'ROLES'
}
export { role }
